const accessKeysFR = {
    "view": {
        "title": "Clés d'accès",
        "form": {
            "label": {
                "accessKeyId": "ID de clé d'accès",
                "secretAccessKey": "Clé d'accès secrète"
            },
            "button": {
                "hide": "Cacher",
                "reveal": "Révéler"
            },
            "message": {
                "accessKeyIdCopied": "ID de clé d'accès copié dans le presse-papiers !",
                "secretAccessKeyCopied": "Clé d'accès secrète copiée dans le presse-papiers !"
            }
        },
        "uploadInstructions": {
            "title": "Instructions",
            "step1": {
                "title": "Étape 1 - Télécharger l'outil de téléchargement",
                "description": "Téléchargez l'outil <1>Cyberduck</1>."
            },
            "step2": {
                "title": "Étape 2 - Faites une copie de la feuille de calcul de téléchargement et enregistrez le fichier déclencheur",
                "descriptionPoint1": "Copiez cette <1><strong>FEUILLE DE CALCUL</strong></1> dans votre GOOGLE DRIVE.",
                "descriptionPoint2": "Enregistrez ce <1><strong>FICHIER DÉCLENCHEUR</strong></1> sur votre ordinateur ou stockage cloud."
            },
            "step3": {
                "title": "Étape 3 - Établir la connexion",
                "descriptionPoint1": "Ouvrez l'outil Cyberduck.",
                "descriptionPoint2": "Dans le coin inférieur gauche, cliquez sur l'icône +. (Ajouter un nouveau signet).",
                "descriptionPoint3": "Saisissez les informations d'identification suivantes :",
                "descriptionPoint4": "ID de clé d'accès : ",
                "descriptionPoint5": "Clé d'accès secrète : ",
                "descriptionPoint6": "Votre dossier S3 : ",
                "descriptionPoint7": "Votre chemin S3 : ",
                "descriptionPoint8": "Suivez ces étapes :"
            },
            "step4": {
                "title": "Étape 4 - Remplir les métadonnées",
                "description": "Remplissez les métadonnées selon les instructions de notre Centre d'aide."
            },
            "step5": {
                "title": "Étape 5 - Fichiers et genres",
                "descriptionPoint1": "Téléchargez votre fichier <1>metadata.csv</1> et tous les fichiers audio <3>(.wav)</3> et <5>image (.jpg)</5>, <7> PAS (.jpeg)</7>",
                "descriptionPoint2": "Les <strong>fichiers JPG</strong> doivent être <strong>3000x3000 px, taille max des fichiers 4MB</strong>",
                "descriptionPoint3": "Les fichiers audio doivent être uniquement <strong>wav, 16 bits, 44,1 khz</strong>",
                "descriptionPoint4": "Les noms de fichiers racine doivent être un seul mot",
                "descriptionPoint5": "<strong>IMPORTANT :</strong> Faites attention aux <2><strong>Genres de danse ML</strong></2> et à la correspondance dans les magasins tels que Beatport."
            },
            "step6": {
                "title": "Étape 6 - Déclencheur de téléchargement",
                "description": "Après que tous les fichiers soient téléchargés, veuillez télécharger ce fichier déclencheur vide <1>“last.zzz”</1>. Surveillez votre email pour toute notification."
            },
            "step7": {
                "title": "Conseil - Testez avec nous avant de télécharger",
                "description": "N'hésitez pas à contacter notre équipe de support pour toute question concernant cette méthode de création de sortie. C'est un processus très simple qui repose sur des technologies plus robustes telles que AWS S3 et ne dépend pas des technologies de navigateur. Cependant, il nécessite que vos métadonnées soient 100 % exactes. L'équipe Music Link peut tester le téléchargement de quelques sorties pour vous avec vos métadonnées afin de détecter d'éventuels problèmes."
            }
        }
    }
};

export default accessKeysFR;